import request from '@/router/axios'

export function fetchCourseCoursewareStatisticsSummary (params) {
  return request({
    url: '/course/admin/analysis/course-courseware',
    method: 'get',
    params,
  })
}

export function exportCourseCoursewareStatisticsSummary (params) {
  return request({
    url: '/course/admin/analysis/course-courseware/export',
    method: 'get',
    params,
  })
}
